<template>
  <div>
    <p>
      <strong>{{ $t("contract.education.headline") }}</strong>
    </p>
    <p>{{ $t('contract.education.paragraphs.first') }}</p>
    <p v-show="education.extended">
      {{ $t('contract.education.paragraphs.second') }}
      <label class="user-output">{{ education.extendedDescription }}</label>
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    education() {
      return this.$store.state.contract.education;
    }
  }
};
</script>
